<template lang="html">
    <nav class="btn-group">
        <button v-for="(tab,index) in tabList" :key="index" :class="`btn btn-secondary ${ tab.isActive ? 'is-active' : ''}`" @click="changeTab(tab)">{{ tab.name }}</button>
    </nav>
</template>

<script>
    export default {
        name: 'tabButtons',
        props: {
            tabs: null,
        },
        data() {
            return {
                tabList: null
            }
        },
        methods: {
            changeTab(selectedTab) {
                this.tabList.forEach(tab => {
                    tab.isActive = tab.name === selectedTab.name;
                    if (tab.name === selectedTab.name) {
                        this.$emit('changeTab', {name: tab.name});
                    }
                })
            }
        },
        mounted() {
            this.tabList = this.tabs;
        }
    }
</script>

<style lang="css">
</style>
